import { useState } from "react";
import { Form } from "@payping/web-components";
import { IBANItem } from "../types";

export const useIBANModal = () => {
  const [showAddIBANModal, setShowAddIBANModal] = useState(false);
  const [addIBANForm] = Form.useForm();

  const handleModalClose = () => {
    setShowAddIBANModal(false);
    addIBANForm.resetFields();
  };

  const handleEditIBAN = (iban: IBANItem) => {
    addIBANForm.setFieldsValue({
      title: iban.title,
      iban: iban.iban.replace("IR", ""),
    });
    setShowAddIBANModal(true);
  };

  return {
    showAddIBANModal,
    setShowAddIBANModal,
    addIBANForm,
    handleModalClose,
    handleEditIBAN,
  };
};

